import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, formatIntToCurrency, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useLabel } from "~/hooks/use-label";
import { useLabelManager } from "~/managers/use-label-manager";
import { Label } from "~/providers/label-provider";

export const Route = createFileRoute("/_main/settings/_layout/labels/")({
  component: LabelsSettingsPage,
});

function LabelsSettingsPage() {
  const { t } = useTranslation("common");

  const { labels } = useLabel();

  const { openLabelForm } = useLabelManager();

  const columns: ColumnDef<Label>[] = [
    {
      id: t("name"),
      accessorKey: "text",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: label }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html: highlightText(label.text, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
    {
      id: t("position"),
      accessorKey: "position",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("position")} />
      ),
      cell: ({ row: { original: label }, table }) => {
        const globalFilter = table.getState().globalFilter as string;

        return (
          <p
            dangerouslySetInnerHTML={{
              __html:
                highlightText(label.position.toString(), globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("Labels.page_title")}
        buttonLabel={capitalize(t("Labels.new_label"))}
        buttonAction={() => openLabelForm()}
      />

      <DataTable
        defaultSorting={[{ id: t("position"), desc: false }]}
        columns={columns}
        data={labels}
        onSelect={openLabelForm}
      />
    </>
  );
}
